/**
 * Recorre el árbol de menús y devuelve productos marcados como acceso rápido.
 * Misma lógica de recorrido que el TPV (tpvProductsByCategory / tpvListProductsTopChoice).
 */
export function getQuickAccessProducts(menus) {
	const quickAccessProducts = [];

	if (!Array.isArray(menus)) {
		return quickAccessProducts;
	}

	menus.forEach((menu) => {
		if (Array.isArray(menu.menuCategories)) {
			menu.menuCategories.forEach((menuCategory) => {
				if (Array.isArray(menuCategory.children) && menuCategory.children.length > 0) {
					menuCategory.children.forEach((firtsChildren) => {
						if (Array.isArray(firtsChildren.children) && firtsChildren.children.length > 0) {
							firtsChildren.children.forEach((secondChildren) => {
								if (Array.isArray(secondChildren.menuCategories)) {
									secondChildren.menuCategories.forEach((category) => {
										if (Array.isArray(category.products)) {
											category.products.forEach((product) => {
												if (product.quickAccess?.isQuickAccess) {
													quickAccessProducts.push(product);
												}
											});
										}
									});
								}
							});
						} else if (Array.isArray(firtsChildren.menuCategories)) {
							firtsChildren.menuCategories.forEach((category) => {
								if (Array.isArray(category.products)) {
									category.products.forEach((product) => {
										if (product.quickAccess?.isQuickAccess) {
											quickAccessProducts.push(product);
										}
									});
								}
							});
						}
					});
				} else if (Array.isArray(menuCategory.products)) {
					menuCategory.products.forEach((product) => {
						if (product.quickAccess?.isQuickAccess) {
							quickAccessProducts.push(product);
						}
					});
				}
			});
		}
	});

	return quickAccessProducts;
}
